import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  EventExpense,
  EventExpenseCategory,
  SaveEventExpenseData,
} from '../../types/Event';

@Injectable()
export class EventExpenseApiService {
  private readonly expensesUrl = `${apiConfiguration.baseApiUrl}/event-expenses`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getExpenses(): Promise<HttpResponse<EventExpense[]>> {
    return lastValueFrom(this.http.get<HttpResponse<EventExpense[]>>(this.expensesUrl, { headers: this.getHeaders() }));
  }

  public async getExpense(expenseId: string): Promise<HttpResponse<EventExpense | null>> {
    return lastValueFrom(this.http.get<HttpResponse<EventExpense | null>>(`${this.expensesUrl}/${expenseId}`, { headers: this.getHeaders() }));
  }

  public async getExpenseCategories(): Promise<HttpResponse<EventExpenseCategory[]>> {
    return lastValueFrom(this.http.get<HttpResponse<EventExpenseCategory[]>>(`${this.expensesUrl}/categories`, { headers: this.getHeaders() }));
  }

  public async createExpense(data: SaveEventExpenseData): Promise<HttpResponse<EventExpense>> {
    return lastValueFrom(this.http.post<HttpResponse<EventExpense>>(this.expensesUrl, data, { headers: this.getHeaders() }));
  }

  public async updateExpense(expenseId: string, data: Partial<SaveEventExpenseData>): Promise<HttpResponse<EventExpense>> {
    return lastValueFrom(this.http.put<HttpResponse<EventExpense>>(`${this.expensesUrl}/${expenseId}`, data, { headers: this.getHeaders() }));
  }

  public async deleteExpense(expenseId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.expensesUrl}/${expenseId}`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
